<script lang="ts">
  import { onMount } from 'svelte';
  import { entityStore, uiState, setUIState } from '$lib/stores/entityStore';
  import DataTable from '$lib/components/drawers/client/edit/tabs/components/EntityDataTable.svelte';
  import CreateEntityPage from '$lib/components/drawers/client/edit/tabs/components/CreateEntityPage.svelte';
  import UpdateEntityPage from '$lib/components/drawers/client/edit/tabs/components/UpdateEntityPage.svelte';
  import Button from '$lib/components/common/button/Button.svelte';
  import { fade } from 'svelte/transition';

  export let clientId: number;

  onMount(async () => {
    setUIState('DataTable');
  });

</script>

{#if $uiState === 'DataTable'}
  <div in:fade>
      <div class="mt-5 flex justify-end">
        <Button label="Add Entity" size="medium" colour="primary" icon="plus-square" onClick={() => setUIState('CreateEntityPage')} />
      </div>
      <DataTable bind:clientId />
  </div>
{:else if $uiState === 'CreateEntityPage'}
  <div in:fade>
    <CreateEntityPage {clientId} on:entityCreated={() => setUIState('DataTable')} />
  </div>
{:else if $uiState === 'UpdateEntityPage'}
  <div in:fade>
    <UpdateEntityPage {clientId} on:entityUpdated={() => setUIState('DataTable')} />
  </div>
{/if}
